import { render, staticRenderFns } from "./CoreSelect.vue?vue&type=template&id=08f9b4fd&scoped=true"
import script from "./CoreSelect.vue?vue&type=script&lang=js"
export * from "./CoreSelect.vue?vue&type=script&lang=js"
import style0 from "./CoreSelect.vue?vue&type=style&index=0&id=08f9b4fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f9b4fd",
  null
  
)

export default component.exports